export const modifyKeyToString = (value: string): string =>
  value.replace(value[0], value[0].toUpperCase()).split('_').join(' ');
